
import { Vue, Component } from 'vue-property-decorator';
import Game from '@/components/games/Game.vue';
import Container from '@/components/layout/Container.vue';

@Component({
  components: { Container, Game },
  props: {
    games: Array,
  },
})
export default class GalleryList extends Vue {}
